import type { JSX } from 'react';
import MaskedInput from 'react-text-mask';

export const DurationField: ({
  name,
  value,
  onChange,
  onBlur,
  ref,
}: {
  name: string;
  value: string | null;
  onChange: (value: string | null) => void;
  onBlur: () => void;
  ref: React.Ref<HTMLInputElement>;
}) => JSX.Element = ({ name, value, onChange, onBlur, ref }) => {
  return (
    <MaskedInput
      mask={[/[0-9]/, /[0-9]/, /[0-9]/, '.', /[0-2]/, /[0-9]/, ':', /[0-6]/, /[0-9]/]}
      placeholder='DDD.HH:MM'
      ref={ref}
      value={value ?? ''}
      name={name}
      className='form-input-m form-input'
      onChange={(e) => onChange(e.target.value === '' ? null : e.target.value)}
      onBlur={onBlur}
    />
  );
};
